import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CustomAuthForm from '../components/auth/CustomAuthForm';

const UnifiedAuthPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState<'signin' | 'signup'>('signin');

  // Check URL params for mode
  useEffect(() => {
    const urlMode = searchParams.get('mode');
    if (urlMode === 'signup' || urlMode === 'signin') {
      setMode(urlMode);
    }
  }, [searchParams]);

  return <CustomAuthForm mode={mode} />;
};

export default UnifiedAuthPage; 